"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPARTMENT_ES = exports.DEPARTMENT_EN = exports.DEPARTMENT = void 0;
exports.DEPARTMENT = [
    { label: 'Acadêmico / Pedagógico', value: 'academyPedagogic' },
    { label: 'Administrativo', value: 'administrative' },
    {
        label: 'Atendimento / Relacionamento com Cliente',
        value: 'customerService',
    },
    { label: 'Comercial / Vendas', value: 'seller' },
    { label: 'Compras / Suprimentos', value: 'supplies' },
    { label: 'Comunicação / RP', value: 'communication' },
    { label: 'Conselho', value: 'advice' },
    { label: 'Consultoria', value: 'consultancy' },
    { label: 'Design / Criação', value: 'creativeDesign' },
    { label: 'Digital', value: 'digital' },
    { label: 'Engenharia', value: 'engineering' },
    { label: 'Equipe Médica', value: 'medicalTeam' },
    { label: 'Estratégico', value: 'strategic' },
    { label: 'Financeiro', value: 'finance' },
    { label: 'Gestão', value: 'management' },
    { label: 'Governança', value: 'governance' },
    { label: 'Inovação', value: 'innovation' },
    { label: 'Inteligência de Mercado', value: 'marketIntelligence' },
    { label: 'Jurídico / Legal', value: 'juridic' },
    { label: 'Logística / Transporte', value: 'logistics' },
    { label: 'Marketing', value: 'marketing' },
    { label: 'Operações', value: 'operations' },
    { label: 'Pesquisa & Desenvolvimento', value: 'researchAndDevelopment' },
    { label: 'Planejamento', value: 'planing' },
    { label: 'Processos', value: 'planing' },
    { label: 'Produto', value: 'product' },
    { label: 'Qualidade', value: 'quality' },
    { label: 'Recursos Humanos', value: 'humanResources' },
    { label: 'Tecnologia / Ciência de Dados', value: 'dataScience' },
    { label: 'Treinamento e Desenvolvimento', value: 'trainingAndDevelopment' },
    { label: 'Outros', value: 'others' },
];
exports.DEPARTMENT_EN = [
    { label: 'Academic / Pedagogical', value: 'academyPedagogic' },
    { label: 'Administrative', value: 'administrative' },
    {
        label: 'Service / Customer Relationship',
        value: 'customerService',
    },
    { label: 'Commercial / Sales', value: 'seller' },
    { label: 'Purchasing / Supplies', value: 'supplies' },
    { label: 'Communication / PR', value: 'communication' },
    { label: 'Board', value: 'advice' },
    { label: 'Consultancy', value: 'consultancy' },
    { label: 'Design / Creation', value: 'creativeDesign' },
    { label: 'Digital', value: 'digital' },
    { label: 'Engineering', value: 'engineering' },
    { label: 'Medical team', value: 'medicalTeam' },
    { label: 'Strategic', value: 'strategic' },
    { label: 'Financial', value: 'finance' },
    { label: 'Management', value: 'management' },
    { label: 'Governance', value: 'governance' },
    { label: 'Innovation', value: 'innovation' },
    { label: 'Market intelligence', value: 'marketIntelligence' },
    { label: 'Legal / Legal', value: 'juridic' },
    { label: 'Logistics / Transport', value: 'logistics' },
    { label: 'Marketing', value: 'marketing' },
    { label: 'Operations', value: 'operations' },
    { label: 'Search', value: 'researchAndDevelopment' },
    { label: 'Research and Development', value: 'planing' },
    { label: 'Processes', value: 'planing' },
    { label: 'Product', value: 'product' },
    { label: 'Quality', value: 'quality' },
    { label: 'Human Resources', value: 'humanResources' },
    { label: 'Technology / Data Science', value: 'dataScience' },
    { label: 'Training and development', value: 'trainingAndDevelopment' },
    { label: 'Others', value: 'others' },
];
exports.DEPARTMENT_ES = [
    { label: 'Académico / Pedagógico', value: 'academyPedagogic' },
    { label: 'Administrativo', value: 'administrative' },
    {
        label: 'Servicio / Relación con el cliente',
        value: 'customerService',
    },
    { label: 'Ventas comerciales', value: 'seller' },
    { label: 'Compras / Suprimentos', value: 'supplies' },
    { label: 'Comunicación / Relaciones Públicas', value: 'communication' },
    { label: 'Consejo', value: 'advice' },
    { label: 'Consultoría', value: 'consultancy' },
    { label: 'Diseño / Creación', value: 'creativeDesign' },
    { label: 'Digital', value: 'digital' },
    { label: 'Ingenieria', value: 'engineering' },
    { label: 'Equipo médico', value: 'medicalTeam' },
    { label: 'Estratégico', value: 'strategic' },
    { label: 'Financiero', value: 'finance' },
    { label: 'Gestión', value: 'management' },
    { label: 'Gobernancia', value: 'governance' },
    { label: 'Innovación', value: 'innovation' },
    { label: 'Inteligencia de mercado', value: 'marketIntelligence' },
    { label: 'Legal', value: 'juridic' },
    { label: 'Logística / Transporte', value: 'logistics' },
    { label: 'Márketing', value: 'marketing' },
    { label: 'Operaciones', value: 'operations' },
    { label: 'Investigación y Desarrollo', value: 'researchAndDevelopment' },
    { label: 'Planificación', value: 'planing' },
    { label: 'Procesos', value: 'planing' },
    { label: 'Producto', value: 'product' },
    { label: 'Calidad', value: 'quality' },
    { label: 'Recursos Humanos', value: 'humanResources' },
    { label: 'Tecnología / Ciencia de datos', value: 'dataScience' },
    { label: 'Entrenamiento y desarrollo', value: 'trainingAndDevelopment' },
    { label: 'Otros', value: 'others' },
];
//# sourceMappingURL=department.js.map